"use client";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css";
import Link from "next/link";
import Certf from "@/public/images/certf.jpg";
import Image from "next/image";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
Fancybox.bind("[data-fancybox]", {
  dragToClose: false,
  Image: {
    zoom: false,
  },
});
const Certificates = ({ media }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <div className="certificatesDetail">
      <button ref={prevRef} className="swiper-button-prev"></button>
      <button ref={nextRef} className="swiper-button-next"></button>
      <Swiper
        spaceBetween={20}
        slidesPerView={4}
        onSwiper={(swiper) => {
          setTimeout(() => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          });
        }}
        modules={[Navigation]}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        breakpoints={{
          320: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          991: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        }}
      >
        {media?.map((item) => (
          <SwiperSlide key={item.id}>
            <Link
              href={item.slider}
              className="certCard"
              data-fancybox="certifcate-gallery"
            >
              <div className="img">
                <Image
                  src={item.slider}
                  width={200}
                  height={200}
                  alt={item.title}
                />
              </div>
              <p>{item.title}</p>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Certificates;
